import { App } from 'antd';

let notificationApi: ReturnType<typeof App.useApp>['notification'] | null = null;

export const setNotificationApi = (api: ReturnType<typeof App.useApp>['notification']) => {
  notificationApi = api;
};

export const openNotification = ({
  type,
  message,
}: {
  type: 'success' | 'error';
  message: string;
}) => {
  if (notificationApi) {
    notificationApi.open({
      message: message,
      className: `notification ${type}`,
    });
  }
};
